import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

import SearchQuery from '@/propTypes/SearchQuery';
import getStaySummaryText from '@/utils/getStaySummaryText';
import Summary from '../Summary';

const StyledSummary = styled(Summary)`
  font-family: ${themeGet('headerFontFamily')};
  font-weight: ${themeGet('fontWeights.bold')};
`;

const PackageHeroSummary = ({
  searchQuery = undefined,
  exact = false,
  showNights = false,
  nights,
  inverse = false,
  ...props
}) => (
  <StyledSummary
    color={inverse ? 'white' : 'primary'}
    text={
      showNights
        ? getStaySummaryText(nights || searchQuery, exact)
        : 'Flights + hotel'
    }
    {...props}
  />
);

PackageHeroSummary.propTypes = {
  searchQuery: PropTypes.shape(SearchQuery),
  exact: PropTypes.bool,
  showNights: PropTypes.bool,
  inverse: PropTypes.bool,
  nights: PropTypes.number,
};

export default PackageHeroSummary;
